export default __webpack_public_path__ + "static/cnss-7252668663f18f382296ffc4c388dbb3.png";